import { localStorageConstants } from '@/types/LocalStorageConstants';

const { testingHarness } = localStorageConstants;

export const getSubdomain = () => {
  const existingTestingHarness = localStorage.getItem(testingHarness);
  if (existingTestingHarness) {
    try {
      const parsedData = JSON.parse(existingTestingHarness);
      if (parsedData.subDomain) {
        return parsedData.subDomain;
      }
    } catch (e) {
      console.error('INVALID JSON');
    }
  }
  const [subdomain, domain] = window.location.host.split('.');
  if (
    subdomain.startsWith('localhost') ||
    ['capitalone', 'cloudfront'].some((d) => d === domain)
  ) {
    return 'capitalone'; // change this value to test alternative workflows locally
  }
  return subdomain;
};
